import React from 'react';

interface ErrorStateProps {
  error: string | null;
  onGoBack: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error, onGoBack }) => {
  return (
    <div className="bg-black text-white min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Event Not Found</h1>
        <p className="text-gray-400 mb-6">
          {error || 'The event you are looking for does not exist.'}
        </p>
        <button 
          onClick={onGoBack}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default ErrorState;
